export const woltdelivery = {
  oAuthFlowHelp: "Connect my Wolt venue",
  authSuccess: "Authentication successful",
  helpText:
    "Authenticate with Wolt – You will be redirected to Wolt and brought back to Xentral after successful authentication."
};
